const headerData = [
    {
        id: 0,
        tabText: "Disappearing Diamond",
        shortTab: false,
        color: "blueTab"
    },
    {
        id: 1,
        tabText: "1",
        shortTab: true,
        color: "greenTab"
    },
    {
        id: 2,
        tabText: "2",
        shortTab: true,
        color: "redTab"
    },
    {
        id: 3,
        tabText: "3",
        shortTab: true,
        color: "yellowTab"
    },
    {
        id: 4,
        tabText: "4",
        shortTab: true,
        color: "blueTab"
    },
    {
        id: 5,
        tabText: "5",
        shortTab: true,
        color: "greenTab"
    }
]

export default headerData